import React from 'react';
import SubscribedList from '../Subscription/List';
import HomeHeader from './Header';
import SafeAreaInset from '@root/components/SafeAreaInset';
import './style.less';
import usePayMethod from '@root/hooks/usePayMethod';

const Home = () => {
  // 提前获取支付方式
  usePayMethod();

  return (
    <div className="home">
      <HomeHeader />
      <div className="flex-section-auto">
        <SubscribedList />
      </div>
      <SafeAreaInset />
    </div>
  );
};

export default Home;
